import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'suppliers',
    name: 'federated-suppliers',
    component: () => import('./FederatedSuppliersPage.vue'),
    meta: {
      permissions: [Permission.FederatedSubEntitiesView],
    },
  },
] satisfies RouteRecordRaw[];
